module.exports = __webpack_public_path__ + "static/media/BeaconLogo.42fb4f43.svg";